import React, { PropTypes } from 'react';
import classnames from 'classnames';
import Carousel from 'nuka-carousel';

import GalleryDotCursor from './GalleryDotCursor.jsx';
import GalleryArrowRight from './GalleryArrowRight.jsx';
import GalleryArrowLeft from './GalleryArrowLeft.jsx';

export default class Gallery extends React.Component {
  static propTypes = {
    small: PropTypes.bool,
    color: PropTypes.string,
    slidesToShow: PropTypes.number,
    children: PropTypes.node,
    onSlideChange: PropTypes.func,
    slideIndex: PropTypes.number,
    hideDotCursor: PropTypes.bool,
  };
  static defaultProps = {
    color: 'white',
    slidesToShow: 1,
    small: false,
    slideIndex: 0,
  };


  constructor(props) {
    super(props);

    const { hideDotCursor } = this.props;

    this.state = {
      maxSlidesToShow: Infinity,
    };

    this.decorators = [
      {
        component: GalleryArrowLeft,
        position: 'CenterLeft',
      },
      {
        component: GalleryArrowRight,
        position: 'CenterRight',
      },
    ];

    if (!hideDotCursor) {
      this.decorators.push({
        component: GalleryDotCursor,
        position: 'BottomCenter',
      });
    }
  }

  componentDidMount() {
    this.onResizeHandler();
    window.addEventListener('resize', this.onResizeHandler);
  }

  onResizeHandler = () => {
    const width = window.innerWidth;

    if (width > 1090) {
      this.setState({
        maxSlidesToShow: 4,
      });
    } else if (width > 900) {
      this.setState({
        maxSlidesToShow: 3,
      });
    } else if (width > 700) {
      this.setState({
        maxSlidesToShow: 2,
      });
    } else {
      this.setState({
        maxSlidesToShow: 1,
      });
    }
  }

  render() {
    const {
      children,
      small,
      slidesToShow,
      color,
      onSlideChange,
      slideIndex,
    } = this.props;

    const slidesToShowChecked = (slidesToShow > this.state.maxSlidesToShow) ?
      this.state.maxSlidesToShow : slidesToShow;

    const styles = {
      wrapper: classnames({
        gallery: true,
        'gallery--white': color === 'white',
        'gallery--black': color === 'black',
        'gallery--small': small,
      }),
    };

    if (children) {
      return (
        <Carousel
          beforeSlide={onSlideChange}
          className={styles.wrapper}
          decorators={this.decorators}
          slidesToShow={slidesToShowChecked}
          cellSpacing={30}
          slideIndex={slideIndex}
        >
          {children}
        </Carousel>
      );
    }

    return null;
  }

}



/** WEBPACK FOOTER **
 ** ./web/js/components/Gallery/Gallery.jsx
 **/